import request from "@/utils/request";
export function getPage(condition, pagination) {
  return request({
    url: "/product/flotsam/page",
    method: "post",
    data: { condition: condition, pagination: pagination },
  });
}
export function get(id) {
  return request({
    url: "/product/flotsam/get",
    method: "get",
    params: { id },
  });
}
export function updateInventory(data) {
  return request({
    url: "/product/flotsam/updateInventory",
    method: "post",
    data
  });
}
export function getPagePopup(condition, pagination) {
  return request({
    url: "/product/flotsam/pagePopup",
    method: "post",
    data: { condition: condition, pagination: pagination },
  });
}
export function getPageListPopup(condition, pagination) {
  return request({
    url: "/product/flotsam/pageListPopup",
    method: "post",
    data: { condition: condition, pagination: pagination },
  });
}

